import { SUPPORT_PORTAL_AUTH_TOKEN_KEY } from "../../../utils/constants";

import { updateState } from "../utils";
import * as actionTypes from "../actionTypes";

const initialState = {
    token: localStorage.getItem(SUPPORT_PORTAL_AUTH_TOKEN_KEY) || null,
    socketToken: null,
    userData: null,
    supports: null,
};

const updateToken = (state, action) => {
    return updateState(state, {
        token: action.token,
    });
};

const updateSocketToken = (state, action) => {
    return updateState(state, {
        socketToken: action.socketToken,
    });
};

const updateUserData = (state, action) => {
    return updateState(state, {
        userData: action.userData,
    });
};

const updateSupports = (state, action) => {
    return updateState(state, {
        supports: action.supports,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_TOKEN:
            return updateToken(state, action);
        case actionTypes.UPDATE_SOCKET_TOKEN:
            return updateSocketToken(state, action);
        case actionTypes.UPDATE_USER_DATA:
            return updateUserData(state, action);
        case actionTypes.UPDATE_SUPPORTS:
            return updateSupports(state, action);
        default:
            return state;
    }
};

export default reducer;
